<template>
  <div class="container">
    <v-row>
      <v-col cols="0" lg="3" xl="4"></v-col>
      <v-col cols="12" lg="6" xl="4">
        <v-card class="mt-16" style="margin: 0 auto; max-width: 450px"
          ><v-system-bar
            color="blue-grey darken-1"
            dark
            height="8"
          ></v-system-bar
          ><v-row>
            <v-col class="text-right" cols="12"> </v-col>
            <v-row class="pa-10 pb-4" align="center" justify="center">
              <v-col class="text-center">
                <h3 class="text-h5 mb-2" @click="email = 'gmail.com'">
                  {{ !user ? name : "設定登入電子郵件與密碼" }}
                </h3>
                <span class="grey--text text--lighten-1">{{
                  !user
                    ? "Sign In With Email And Password"
                    : "Link Email Address And Password Credentials"
                }}</span>
              </v-col>
            </v-row>
          </v-row>
          <v-form>
            <v-container>
              <v-row class="px-4">
                <v-col cols="12" md="12">
                  <v-text-field
                    v-if="!(user && user.providerData.length > 1)"
                    v-model="email"
                    color="blue-grey lighten-2"
                    label="信箱"
                  ></v-text-field>
                  <v-text-field
                    v-if="!(user && user.providerData.length > 1)"
                    v-model="password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show1 ? 'text' : 'password'"
                    name="input-10-1"
                    label="密碼"
                    @click:append="show1 = !show1"
                  ></v-text-field>
                  <v-row>
                    <v-col cols="12" v-if="!user"
                      ><v-btn
                        color="blue-grey darken-1 mt-4 rounded-pill"
                        hight="41"
                        dark
                        block
                        depressed
                        @click="mailSignin()"
                      >
                        登入
                      </v-btn></v-col
                    >
                    <v-col
                      cols="6"
                      v-if="user && user.providerData.length === 1"
                      ><v-btn
                        color="blue-grey darken-1 mt-4 rounded-pill"
                        hight="41"
                        dark
                        block
                        depressed
                        @click="sendSignInLink()"
                      >
                        寄送驗證郵件
                      </v-btn></v-col
                    ><v-col
                      cols="6"
                      v-if="user && user.providerData.length === 1"
                      ><v-btn
                        color="blue-grey darken-1 mt-4 rounded-pill"
                        hight="41"
                        dark
                        block
                        depressed
                        @click="mailLinkSignIn()"
                      >
                        驗證郵件連結
                      </v-btn></v-col
                    >
                    <v-col
                      cols="12"
                      v-if="user && user.providerData.length === 1"
                      ><v-btn
                        color="blue-grey darken-1 mt-4 rounded-pill"
                        hight="41"
                        dark
                        block
                        depressed
                        @click="linkWithEmail()"
                      >
                        綁定信箱
                      </v-btn></v-col
                    >
                    <v-col cols="12" v-if="user && user.providerData.length > 1"
                      ><h4
                        class="text-h6 text-center mt-2 mb-6"
                        style="border: 1px dashed #000"
                      >
                        {{ user.email }}
                      </h4>
                      <!-- <v-btn
                        color="blue-grey darken-1 mt-2 mb-2 rounded-pill"
                        hight="41"
                        dark
                        block
                        depressed
                        @click="unlinkWithEmail()"
                      >
                        解除綁定
                      </v-btn> -->
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>

        <v-card
          class="mt-16"
          style="margin: 0 auto; max-width: 450px"
          v-if="!user"
          ><v-system-bar
            color="blue-grey darken-1"
            dark
            height="8"
          ></v-system-bar
          ><v-row>
            <v-col class="text-right" cols="12"> </v-col>
            <v-row class="pa-10 pb-4" align="center" justify="center">
              <v-col class="text-center">
                <h3 class="text-h5 mb-2" @click="phoneNumber = '+886988778461'">
                  {{ name }}
                </h3>
                <span class="grey--text text--lighten-1">{{ title }}</span>
              </v-col>
            </v-row>
          </v-row>
          <v-form id="demo-form">
            <v-container>
              <v-row class="px-4">
                <v-col cols="12" md="12">
                  <v-text-field
                    v-model="phoneNumber"
                    color="blue-grey lighten-2"
                    label="手機號碼"
                    @keyup.enter="sendCaptcha()"
                  ></v-text-field>

                  <div id="recaptcha-container"></div>

                  <v-btn
                    color="blue-grey darken-1 mt-4 rounded-pill"
                    hight="41"
                    dark
                    block
                    depressed
                    class="mb-6"
                    @click="sendCaptcha()"
                  >
                    寄送驗證碼
                  </v-btn>
                  <div v-if="isConfirmationResult">
                    <v-otp-input
                      class="px-12"
                      v-model="verificationCode"
                      length="6"
                    ></v-otp-input>
                    <v-row>
                      <v-col cols="12"
                        ><v-btn
                          color="blue-grey darken-1 mt-4 rounded-pill"
                          hight="41"
                          dark
                          block
                          depressed
                          @click="phoneSignin()"
                        >
                          登入
                        </v-btn></v-col
                      >
                      <!--<v-col cols="6"
                        ><v-btn
                          color="blue-grey darken-1 mt-4 rounded-pill"
                          hight="41"
                          dark
                          block
                          depressed
                          @click="logOut()"
                        >
                          Sign Out
                        </v-btn></v-col
                      >-->
                    </v-row>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
      <v-col cols="0" lg="3" xl="4"></v-col>
    </v-row>
  </div>
</template>

<script>
import "firebase/auth";
import { db } from "@/firebase";
import {
  //auth,
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  onAuthStateChanged,
  signOut,
  deleteUser,
  updateProfile,
  setPersistence,
  browserSessionPersistence,
  EmailAuthProvider,
  linkWithCredential,
  unlink,
  sendSignInLinkToEmail,
  isSignInWithEmailLink,
  signInWithEmailLink,
} from "firebase/auth";

import {
  // query,
  // where,
  getDocs,
  collection,
  // documentId,
} from "firebase/firestore/lite";

export default {
  data() {
    return {
      desserts: [],
      show1: false,
      name: "統一企業集團特約商店",
      title: "Sign In With Phone Number",
      account: "",
      user: "",
      errorCode: "",
      errorMessage: "",
      email: "",
      password: "",
      phoneNumber: "+886",
      verificationCode: "",
      isConfirmationResult: false,
      isAdmin: true,
    };
  },

  watch: {},
  created() {
    // this.createUser()
    // this.getUser();
    // this.updateUser();
    this.check();
    this.$bus.$emit("sideBarSelectedItem:push", 1);
  },

  methods: {
    sendSignInLink() {
      console.log("寄出");
      const actionCodeSettings = {
        // URL you want to redirect back to. The domain (www.example.com) for this
        // URL must be in the authorized domains list in the Firebase Console.
        url: "https://pec-eps-4819c.web.app/#/",
        // This must be true.
        handleCodeInApp: true,
      };
      const auth = getAuth();
      sendSignInLinkToEmail(auth, this.email, actionCodeSettings)
        .then(() => {
          // The link was successfully sent. Inform the user.
          // Save the email locally so you don't need to ask the user for it again
          // if they open the link on the same device.
          window.localStorage.setItem("emailForSignIn", this.email);
          // ...
        })
        .catch((error) => {
          console.log(error);
        });
    },
    mailLinkSignIn() {
      const auth = getAuth();
      if (isSignInWithEmailLink(auth, window.location.href)) {
        // Additional state parameters can also be passed via URL.
        // This can be used to continue the user's intended action before triggering
        // the sign-in operation.
        // Get the email if available. This should be available if the user completes
        // the flow on the same device where they started it.
        let email = window.localStorage.getItem("emailForSignIn");
        if (!email) {
          // User opened the link on a different device. To prevent session fixation
          // attacks, ask the user to provide the associated email again. For example:
          email = window.prompt("Please provide your email for confirmation");
        }
        // The client SDK will parse the code from the link for you.
        signInWithEmailLink(auth, email, window.location.href)
          .then((result) => {
            // Clear email from storage.
            window.localStorage.removeItem("emailForSignIn");
            console.log("??", result);
            // You can access the new user via result.user
            // Additional user info profile not available via:
            // result.additionalUserInfo.profile == null
            // You can check if the user is new or existing:
            // result.additionalUserInfo.isNewUser
          })
          .catch((error) => {
            console.log("??", error);
            // Some error occurred, you can inspect the code: error.code
            // Common errors could be invalid email and invalid or expired OTPs.
          });
      }
    },

    linkWithEmail() {
      const credential = EmailAuthProvider.credential(
        this.email,
        this.password
      );
      const auth = getAuth();
      linkWithCredential(auth.currentUser, credential)
        .then((usercred) => {
          const user = usercred.user;
          this.$snackbar.add(`綁定成功`, { color: "success" });
          console.log("Account linking success", user);
          this.email = "";
          this.password = "";
        })
        .catch((error) => {
          console.log("Account linking error", error);
          this.$snackbar.add(`綁定失敗 : ${error}`, { color: "error" });
        });
    },

    unlinkWithEmail() {
      const auth = getAuth();
      unlink(auth.currentUser, "password")
        .then(() => {
          console.log("解除成功");
          this.$snackbar.add(`解除成功`, { color: "success" });
        })
        .catch((error) => {
          console.log(error);
          this.$snackbar.add(`解除失敗 : ${error}`, { color: "error" });
        });
    },

    async sendCaptcha() {
      this.phoneNumber = this.phoneNumber.replace(/\s*/g, "");
      await fetch(
        `https://eps.pec.com.tw/api/FireBase/getManagersByPhoneNumber?phoneNumber=${encodeURIComponent(
          this.phoneNumber
        )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          if (data.result.msg == "取得成功") {
            const auth = getAuth();
            window.recaptchaVerifier = new RecaptchaVerifier(
              "recaptcha-container",
              {
                size: "invisible",
                callback: (response) => {
                  // reCAPTCHA solved, allow signInWithPhoneNumber.
                  console.log(response);
                },
                "expired-callback": () => {},
              },
              auth
            );
            this.phoneNumber = data.result.getDocumentId[0];
            const phoneNumber = this.phoneNumber;
            const appVerifier = window.recaptchaVerifier;
            setPersistence(auth, browserSessionPersistence).then(() => {
              // Existing and future Auth states are now persisted in the current
              // session only. Closing the window would clear any existing state even
              // if a user forgets to sign out.
              // ...
              // New sign-in will be persisted with session persistence.
              return signInWithPhoneNumber(auth, phoneNumber, appVerifier)
                .then((confirmationResult) => {
                  // SMS sent. Prompt user to type the code from the message, then sign the
                  // user in with confirmationResult.confirm(code).
                  this.isConfirmationResult = true;
                  window.confirmationResult = confirmationResult;
                  console.log("已寄出驗證簡訊", confirmationResult);
                  this.$snackbar.add(`已寄出驗證簡訊`, { color: "success" });
                })
                .catch((error) => {
                  console.log("驗證簡訊寄出失敗", error);
                  this.$snackbar.add(`驗證簡訊寄出失敗`, { color: "error" });
                });
            });
          } else {
            this.$snackbar.add(`${data.result.msg}`, { color: "error" });
          }
        });
    },
    phoneSignin() {
      if (this.verificationCode) {
        window.confirmationResult
          .confirm(this.verificationCode)
          .then(async (result) => {
            // User signed in successfully.
            const user = result.user;
            console.log("登入成功", user);
            this.$snackbar.add(`登入成功`, { color: "success" });
            this.$bus.$emit("check:push");
            await getDocs(collection(db, "managers"))
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  console.log(doc.id, " => ", doc.data());
                  this.desserts.push(doc.data());
                });
                this.isAdmin = true;
                this.$router.push("/store");
              })
              .catch(() => {
                this.isAdmin = false;
                this.$router.push("/");
              });
          })
          .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log(
              "errorCode：",
              errorCode,
              "errorMessage：",
              errorMessage
            );
            this.$snackbar.add(`驗證碼錯誤`, { color: "error" });
          });
      } else {
        this.$snackbar.add(`請輸入驗證碼`, { color: "error" });
      }
    },
    getUser() {
      const auth = getAuth();
      const user = auth.currentUser;

      if (user !== null) {
        this.user = user;
        user.providerData.forEach((profile) => {
          console.log("  Sign-in provider: " + profile.providerId);
          console.log("  Provider-specific UID: " + profile.uid);
          console.log("  Name: " + profile.displayName);
          console.log("  Email: " + profile.email);
          console.log("  Photo URL: " + profile.photoURL);
        });
      }
    },
    updateUser() {
      const auth = getAuth();
      updateProfile(auth.currentUser, {
        disabled: false,
      })
        .then(() => {
          // Profile updated!
          // ...
          console.log("更新完成");
        })
        .catch((error) => {
          // An error occurred
          // ...
          console.log(error);
        });
    },
    deleteUser() {
      const auth = getAuth();
      const user = auth.currentUser;

      deleteUser(user)
        .then(() => {
          // User deleted.
        })
        .catch((error) => {
          // An error ocurred
          console.log(error);
        });
    },
    createUser() {
      const auth = getAuth();
      createUserWithEmailAndPassword(auth, this.email, this.password)
        .then((userCredential) => {
          // Signed in
          const user = userCredential.user;
          console.log(user);
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(errorCode, errorMessage);
        });
    },
    mailSignin() {
      const auth = getAuth();
      setPersistence(auth, browserSessionPersistence)
        .then(() => {
          // Existing and future Auth states are now persisted in the current
          // session only. Closing the window would clear any existing state even
          // if a user forgets to sign out.
          // ...
          // New sign-in will be persisted with session persistence.
          return signInWithEmailAndPassword(auth, this.email, this.password)
            .then(async (userCredential) => {
              // Signed in
              const user = userCredential.user;
              console.log("登入成功", user);
              this.$snackbar.add(`登入成功`, { color: "success" });
              this.$bus.$emit("check:push");
              await getDocs(collection(db, "managers"))
                .then((querySnapshot) => {
                  querySnapshot.forEach((doc) => {
                    console.log(doc.id, " => ", doc.data());
                    this.desserts.push(doc.data());
                  });
                  this.isAdmin = true;
                  this.$router.push("/store");
                })
                .catch(() => {
                  this.isAdmin = false;
                  this.$router.push("/");
                });
            })
            .catch((error) => {
              const errorCode = error.code;
              const errorMessage = error.message;
              console.log(
                "errorCode：",
                errorCode,
                "errorMessage：",
                errorMessage
              );
              this.$snackbar.add(`登入失敗`, { color: "error" });
            });
        })
        .catch((error) => {
          // Handle Errors here.
          console.log(error);
          // const errorCode = error.code;
          // const errorMessage = error.message;
        });
    },
    check() {
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user) {
          // User is signed in, see docs for a list of available properties
          // https://firebase.google.com/docs/reference/js/firebase.User
          this.user = user;
          console.log("Check - 已登入", user);
        } else {
          // User is signed out
          // ...
          console.log("Check - 未登入");
        }
      });
    },
    logOut() {
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          // Sign-out successful.
          console.log("登出成功");
          this.$snackbar.add(`登出成功`, { color: "success" });
          this.user = "";
          // this.$router.push("/");
          this.$bus.$emit("check:push");
        })
        .catch((error) => {
          // An error happened.
          console.log(error);
        });
    },
  },
};
</script>
